import React from 'react';
import HighlightFeature, {
  ACTION_DRILLDOWN,
  CREATE_CHART,
  LEFT,
  SUMMARIZE,
} from '@/components/HighlightFeature';

export const DrilldownOnboarding = () => (
  <HighlightFeature
    requiredActions={[SUMMARIZE, CREATE_CHART]}
    position={LEFT}
    text={
      <span>
        Click the <b>drilldown</b> buttons to explore connected data.
      </span>
    }
    targetAction={ACTION_DRILLDOWN}
    style={{ textAlign: 'left', minWidth: '270px' }}
    hideButton
    delay={1500}
    hideWhenModalsOpen
  />
);
